import { updateFileIdsInMessage } from '../../_internal/operators/updateFileIdsInMessage';
export const addFileIdToMessage = (fileId, message) => {
  return updateFileIdsInMessage(message, currentFileIds => currentFileIds.unshift(fileId));
};